import { GET_PAYMENT_DEMONSTRATIVE, GET_REPORTS_BEING_GENERATED, REMOVE_PAYMENT_DEMONSTRATIVE } from 'store/constants'

export function generateDocs(values) {
  return {
    type: GET_PAYMENT_DEMONSTRATIVE,
    payload: values,
  }
}

export function getReportsBeingGenerated() {
  return {
    type: GET_REPORTS_BEING_GENERATED,
  }
}

export function removeDoc(values) {
  return {
    type: REMOVE_PAYMENT_DEMONSTRATIVE,
    payload: values,
  }
}